module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_mision.11fc96fc.jpg";